var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-input-group",
    [
      _c(
        "b-input-group-prepend",
        { attrs: { title: this.$t("message.language"), "is-text": "" } },
        [_c("span", { staticClass: "fa fa-language text-primary" })]
      ),
      _c(
        "b-form-select",
        {
          staticClass: "bg-widget",
          on: { change: _vm.onLocaleSelected },
          model: {
            value: _vm.selectedItem,
            callback: function ($$v) {
              _vm.selectedItem = $$v
            },
            expression: "selectedItem",
          },
        },
        _vm._l(_vm.$i18n.availableLocales, function (locale) {
          return _c(
            "b-form-select-option",
            {
              key: `locale-${locale}`,
              attrs: { value: locale, title: _vm.$t(`language.${locale}`) },
            },
            [
              _c("span", { staticClass: "mr-2" }, [
                _vm._v(_vm._s(_vm.localeToFlag(locale))),
              ]),
              _vm._v("\n      " + _vm._s(locale.toUpperCase()) + "\n    "),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }